import dynamic from 'next/dynamic';

export * from './hooks/use-geo-distance.hook';
export * from './hooks/use-geo-json.hook';

export const Map = dynamic(() => import('./map'), { ssr: false });
